<template>
  <g>
    <g
      v-if="back"
      :transform="`translate(${x + depthOffset.x}, ${y - depthOffset.y - height})`"
    >
      <rect
        class="backRect"
        :width="width"
        :height="height"
      />
      <rect
        class="backRect-holes"
        fill="url(#holes)"
        x="14"
        y="8"
        :width="width - 28"
        :height="height - 12"
      />
    </g>
    <g
      v-if="left"
    >
      <polygon
        class="leftPolygon"
        :points="leftPolygon"
      />
      <rect
        class="leftPolygon-holes"
        fill="url(#holes)"
        :x="x + 8"
        :y="y - height + 4"
        :width="depthOffset.x - 16"
        :height="height - 8"
      />
    </g>
    <g
      v-if="right"
    >
      <polygon
        class="rightPolygon"
        :points="rightPolygon"
      />
      <rect
        class="rightPolygon-holes"
        fill="url(#holes)"
        :x="x + width + 8"
        :y="y - height + 4"
        :width="depthOffset.x - 16"
        :height="height - 8"
      />
    </g>
  </g>
</template>

<script>
  export default {
    name: 'Shelf',
    props: {
      x: Number,
      y: Number,
      width: Number,
      height: {
        type: Number,
        default: 50,
      },
      depthOffset: Object,
      left: {
        type: Boolean,
        default: false,
      },
      right: {
        type: Boolean,
        default: false,
      },
      back: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      leftPolygon() {
        return `${this.x},${this.y}
          ${this.x + this.depthOffset.x},${this.y - this.depthOffset.y}
          ${this.x + this.depthOffset.x},${this.y - this.depthOffset.y - this.height}
          ${this.x},${this.y - this.height}`;
      },
      rightPolygon() {
        return `${this.x + this.width},${this.y}
          ${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
          ${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y - this.height}
          ${this.x + this.width},${this.y - this.height}`;
      },
    },
  };
</script>

<style>
  .leftPolygon {
    fill: #d0d0d0;
  }
  .leftPolygon-holes {
    /* fill: url(#holes); */
    transform: skewY(-30deg);
    transform-box: fill-box;
  }
  .rightPolygon {
    fill: #d0d0d0;
  }
  .rightPolygon-holes {
    /* fill: url(#holes); */
    transform: skewY(-30deg);
    transform-box: fill-box;
  }
  .backRect {
    fill: #b9b9b9;
  }
  .backRect-holes {
    /* fill: url(#holes); */
  }
</style>
